import { render, staticRenderFns } from "./successTip.vue?vue&type=template&id=7d19d1b5&scoped=true"
import script from "./successTip.vue?vue&type=script&lang=js"
export * from "./successTip.vue?vue&type=script&lang=js"
import style0 from "./successTip.vue?vue&type=style&index=0&id=7d19d1b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d19d1b5",
  null
  
)

export default component.exports